import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

const selectRuleCategories = createSelector(
  selectUnderwriting,
  ({ ruleCategories }) => ruleCategories,
);

export const selectRuleCategoryValues = createSelector(selectRuleCategories, Object.values);
